import React, { useRef, useState, useEffect } from "react";

import OwlCarousel from "react-owl-carousel";
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";

import SupplierCard from "./SupplierCard";
import { isEqual, map } from "lodash";
import PopUp from "../PopUp";
import SupplierInqPopup from "../Inquiry/SupplierInqPopup";
import { useAuth } from "@/AuthProvider";
import RegistrationPopup from "@/components/RegistrationPopup";
import { Link, useNavigate } from "react-router-dom";
import { publicRoutePaths } from "@/routes/public.routes.config";
import { ToastContainer } from "react-toastify";
import { privateRoutePaths } from "@/routes/private.route.config";
import { buildPath, showSuccessMessage } from "@/utils/common";
import roles from "@/constant/roles.config";
import { useDispatch } from "react-redux";
import { createplanReq } from "@/store/modern/slices/requestslice";

function SupplierCarousel({ suppliers }) {

  const partnerBannersRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [inqmodalshow, setInqModalShow] = useState(false);
  const [regmodalShow, setRegModalShow] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);

  const { user, isEndUser, isViewer, isDemoUser, isPreKYCUser } = useAuth();

  const options = {
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      600: {
        items: 1,
      },
      700: {
        items: 1,
      },
      768: {
        items: 2,
      },
      1080: {
        items: 2,
      },
      1366: {
        items: 3,
      },
      1600: {
        items: 3,
      }
    },
    nav: false,
    dots: false,
    //navText: ["<< ", ">>"],
  }

  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };

  const goToNext = () => {
    partnerBannersRef.current.next();
  };

  const goToPrev = () => {
    partnerBannersRef.current.prev();
  };

  const handleQuoteClick = (sdata) => {
    console.log("click================", sdata, "user ========== ", user);
    setSelectedSupplier(sdata);
    if (user && (isEndUser || user.trade_mode_type === "BUYER")) {
      setInqModalShow(true);
    } else {
      setRegModalShow(true);
    }

  };

  const handleInqClick = () => {
    setRegModalShow(false);
    setInqModalShow(true);
  }

  const handleUpgradePlanClick = async () => {
    if (user) {
      let data = {
        member_id: user.member_id
      }
      const response = await dispatch(createplanReq(data));
      if (response) {
        if (response.type === "upgradePlan/createRequest/fulfilled") {
           setRegModalShow(false);
            if (user.trade_mode_type !== 'SUPPLIER') {
              showSuccessMessage("We have received your upgrade request. Our team will contact you soon.")
            } else {
               setTimeout(() => {
                navigate(`/${getPrefix(user)}${buildPath(privateRoutePaths.ADMIN_CHOOSE_PLAN, { id: user.member_id })}`)
            }, 500);
            }
          
        }
      }
      
    }
  }

  const handleRegistrationPopup = () => {
    let path = publicRoutePaths.REGISTRATION.path;
    navigate(path);
  }

  const redirectFun = (e, id) => {
    e.preventDefault();
    setRegModalShow(false);


    setTimeout(() => {
      // navigate(publicRoutePaths.REGISTRATION.path);
      window.open(publicRoutePaths.REGISTRATION.path);
    }, 100);

  };

   useEffect(() => {
      console.log("regmodalShow:", regmodalShow);
      console.log("user:", user);
  
      if (
          regmodalShow &&
          user?.trade_mode_type === "SUPPLIER" &&
          (user?.company_plan_name !== "Trial")
      ) {
          console.log("Supplier paid user - switching modal");
          if(isPreKYCUser) {
            setInqModalShow(false);
            setRegModalShow(true);
            
          } else {
            setRegModalShow(false);
            setInqModalShow(true);
          }
          
      }

      
  }, [regmodalShow, user,isPreKYCUser]);

  console.log("Hello ---- regmodalShow ",regmodalShow);

  console.log("Hello ---- user ",user);

  console.log("Pry ---- isPreKYCUser ",isPreKYCUser);

  console.log("Hello ---- inqmodalshow ",inqmodalshow);
   
  // useEffect(() => {
  
  //       setInterval(() => {
  //         let u = localStorage.getItem("user");
  //         u = JSON.parse(u);
  //         if(!isEqual(u, user) && user?.company_plan_name !== "Trial" && parseInt(user?.current_step) === 4) {
  //           window.location.reload();
  //         }
  //       },1500);
  //    },[user]);
  useEffect(() => {
  const intervalId = setInterval(() => {
    try {
      const stored = JSON.parse(localStorage.getItem("user"));

      if (
        stored &&
        !isEqual(stored, user) &&
        stored.company_plan_name !== "Trial" &&
        parseInt(stored.current_step) === 4
      ) {
        clearInterval(intervalId);
        window.location.reload();
      }
    } catch (e) {
      console.error("Invalid user in localStorage", e);
    }
  }, 1500);

  return () => clearInterval(intervalId); // cleanup
}, [user]);


  return (
    <div>

      <div className="head-text  button-head">
        <h2 className="head">New suppliers</h2>
        {/* <div className="nav-ctrl">
          <button type="button" className="btn prev" onClick={goToPrev}>
            <i className="sprite"></i>
          </button>
          <button type="button" className="btn next" onClick={goToNext}>
            <i className="sprite"></i>
          </button>
        </div> */}
          <div className="btn-wrape">
            <Link
              className="btn outline medium"
              to={`${publicRoutePaths.SEARCH_SUPPLIERS.path}`}
              title="View All Suppliers"
              href={`${publicRoutePaths.SEARCH_SUPPLIERS.path}`}
              target="_blank"
            >
              View All Suppliers
              <span className="round">
                <i className="sprite"></i>
              </span>
            </Link>
           </div>
      </div>

      {/* <OwlCarousel className='owl-theme section' loop margin={20} autoplay {...options} ref={partnerBannersRef}> */
        <div className="row">
      
        {
          map(suppliers, (val, k) => {
            return (<div className="review item col-md-6  col-xxl-4 col-xl-4 col-lg-4  pb-3" key={`new_s_${k}`}>
              <SupplierCard data={val} key={`s_${k}`} handleQuoteClick={handleQuoteClick} />
            </div>)
          })
        }
      {/* </OwlCarousel> */ }
      
       </div>
      }

      {
        inqmodalshow && (
          <PopUp
            title="Business Inquiry"
            smallmodalShow={inqmodalshow}
            setSmallModalShow={setInqModalShow}
            className="book-demo"
            size="lg"
          >
            <SupplierInqPopup data={selectedSupplier} setInqModalShow={setInqModalShow} from={!user ? "continue_buyer" : ""} />
          </PopUp>
        )
      }

      {
        regmodalShow && <RegistrationPopup
          title=""
          smallmodalShow={regmodalShow}
          setSmallModalShow={setRegModalShow}
          onSubmit={handleRegistrationPopup}
          okButtonLabel={'REGISTER NOW'
          }
        >
          {(() => {
            if (user && isPreKYCUser) {
              return (
                <>
                  <div className="new-pop">
                    <div className="img-wrape"></div>
                    <div className="detail-wrape">
                      <div className="inner">
                        <h5 className="registor-now">Grow With Us!</h5>
                        <h6>Upgrade now to get more benefits!</h6>
                        <p className="registor-now-text">
                          Access special features, get personalized recommendations and connect with a growing community.
                        </p>
                        {/* <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: user.member_id })}`} className="btn secondry-btn" onClick={(e) => {
                          redirectFun(e, user.member_id)
                        }}>
                          Go to Profile
                        </Link> */}
                        <button type="button" className="btn secondry-btn" onClick={handleUpgradePlanClick}>
                          Upgrade Plan
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              );
            } else {
              return (

                <div className="new-pop">
                  <div className="img-wrape"></div>
                  <div className="detail-wrape">
                    <div className="inner">
                      <h5 className="registor-now">Grow With Us!</h5>
                      <p>
                        Select your role to get started:
                      </p>
                      <Link
                        to={publicRoutePaths.REGISTRATION.path}
                        className="popup-category-btn"
                        onClick={(e) => {
                          redirectFun(e, null)
                        }}
                      >
                        <span className="icon supplier"></span>
                        <span className="detail">
                          <h3>Supplier</h3>
                          <p>Sell and showcase your products</p>
                        </span>
                      </Link>
                      <Link
                        to={publicRoutePaths.REGISTRATION.path}
                        className="popup-category-btn"
                        onClick={(e) => {
                          redirectFun(e, null)
                        }}
                      >
                        <span className="icon logistics"></span>
                        <span className="detail">
                          <h3>Logistic Partner</h3>
                          <p>Scaling Your Growth Through Reliable Logistics</p>
                        </span>
                      </Link>
                      <button type="button" className="popup-category-btn" onClick={handleInqClick}>
                        <span className="icon buyer"></span>
                        <span className="detail">
                          <h3>Buyer</h3>
                          <p>Discover and connect with suppliers</p>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              );
            }

          })()}
        </RegistrationPopup>
      }

      <ToastContainer />
    </div>
  )
}

export default SupplierCarousel;
